import React, { useEffect, useState } from 'react';
import { api } from '../../lib/api';

export default function EmployeeOverview() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');
  useEffect(() => { api.get('/employee/stats').then(r=>setD(r.data)).catch(e => setErr(e?.response?.data?.error || 'Failed to load stats')); }, []);
  if (err) return <div className="alert alert-danger">{err}</div>;
  if (!d) return <div><span className="ap-loader" /></div>;
  const { stats } = d;
  const items = [
    ['Listings added', stats.listings_added],
    ['Enquiries assigned', stats.enquiries_assigned],
    ['Enquiries converted', stats.enquiries_converted],
    ['Follow-ups pending', stats.follow_ups_pending],
  ];
  return (
    <div data-testid="employee-overview">
      <h2 className="mb-3">Employee overview</h2>
      <div className="row g-3">
        {items.map(([l,v],i) => (
          <div className="col-6 col-md-3" key={i}>
            <div className="stat-card" data-testid={`emp-stat-${i}`}>
              <div className="stat-label">{l}</div>
              <div className="stat-value">{v}</div>
            </div>
          </div>
        ))}
      </div>
      <div className="ap-card mt-3">
        <h4>Daily activity (last 7d)</h4>
        {d.daily_activity.length === 0 ? <p className="text-muted-2 small">No activity yet. Add listings and manage enquiries to see stats.</p> :
          <ul className="list-unstyled">
            {d.daily_activity.map((x,i)=><li key={i} className="d-flex justify-content-between border-bottom py-2"><span>{x.d}</span><strong>{x.c}</strong></li>)}
          </ul>}
      </div>
    </div>
  );
}
